import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const TableEVS = ({ registrosEVS = [], EliminarRegistroEVS }) => {
    return (
        <div className="new-table-wrapper listado-evs__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Acciones</th>
                        <th>No. EVS</th>
                        <th>Producto</th>
                        <th>Padre de producto</th>
                        <th>Cliente</th>
                        <th>Consumidor final</th>
                    </tr>
                </thead>
                <tbody>
                    {registrosEVS.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center">
                                No hay registros de EVS
                            </td>
                        </tr>
                    )}
                    {registrosEVS.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <div className="table-actions">
                                        <Link to={`/evs/${item.id}/editar`}>
                                            <img
                                                src={editarIcon}
                                                alt="Editar"
                                                className="action_img"
                                                title="Editar"
                                            />
                                        </Link>
                                        <img
                                            src={eliminarIcon}
                                            alt="Eliminar"
                                            className="action_img"
                                            title="Eliminar"
                                            onClick={() =>
                                                EliminarRegistroEVS(item.id)
                                            }
                                        />
                                    </div>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.numero}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.producto_a_producir}
                                    >
                                        {item.producto_a_producir
                                            ? item.producto_a_producir.nombre
                                            : "N/A"}
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.padre_producto_a_producir}
                                    >
                                        {item.padre_producto_a_producir
                                            ? item.padre_producto_a_producir
                                                  .nombre
                                            : "N/A"}
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.cliente}>
                                        {item.cliente
                                            ? item.cliente.nombre
                                            : "N/A"}
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.consumidor_final}
                                    >
                                        {item.consumidor_final
                                            ? item.consumidor_final.nombre
                                            : ""}
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
